// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

function makeRefetchVariables() {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"userNotificationSettingsV5":{"f":""},"currentChapterV5":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

var responseConverter = {"__root":{"userNotificationSettingsV5":{"f":""},"currentChapterV5":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedFor",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": "type_",
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v5 = [
  (v0/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Area",
  "kind": "LinkedField",
  "name": "areas",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userHasInactiveCustomPreference",
    "storageKey": null
  }
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "ChapterDefaultNotificationSetting",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "MatchesOnlyNotificationSetting",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxPrice",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minPrice",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyTypes",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Area",
  "kind": "LinkedField",
  "name": "areas",
  "plural": true,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "areaGroup",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isAreaGroupV5"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Area",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v14/*: any*/)
      ],
      "type": "UserAreaGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/)
      ],
      "type": "ChapterAreaGroup",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mlsStatus",
        "storageKey": null
      },
      (v13/*: any*/),
      (v15/*: any*/)
    ],
    "type": "CustomPropertyNotificationPreference",
    "abstractKey": null
  }
],
v17 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/)
    ],
    "type": "CustomClientNeedNotificationPreference",
    "abstractKey": null
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ChapterAreaGroup",
    "kind": "LinkedField",
    "name": "areaGroup",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          (v7/*: any*/),
          (v0/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/)
            ],
            "type": "UserAreaGroup",
            "abstractKey": null
          }
        ],
        "type": "AreaGroupV5",
        "abstractKey": "__isAreaGroupV5"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailPreferencesPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNotificationSettingsV5",
        "kind": "LinkedField",
        "name": "userNotificationSettingsV5",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationSettings_userNotificationSettings"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChapterV5",
        "kind": "LinkedField",
        "name": "currentChapterV5",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationSettings_chapter"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmailPreferencesPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNotificationSettingsV5",
        "kind": "LinkedField",
        "name": "userNotificationSettingsV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAreaGroup",
            "kind": "LinkedField",
            "name": "userAreaGroups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "forSaleProperties",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "rentalProperties",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "buyerNeeds",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "rentalNeeds",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BroadcastMessageNotificationSettingV5",
            "kind": "LinkedField",
            "name": "broadcastMessages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setting",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChapterV5",
        "kind": "LinkedField",
        "name": "currentChapterV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChapterNotificationPreferencesV5",
            "kind": "LinkedField",
            "name": "notificationPreferences",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterPropertyNotificationPreference",
                "kind": "LinkedField",
                "name": "forSaleProperties",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterPropertyNotificationPreference",
                "kind": "LinkedField",
                "name": "rentalProperties",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterClientNeedNotificationPreference",
                "kind": "LinkedField",
                "name": "buyerNeeds",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterClientNeedNotificationPreference",
                "kind": "LinkedField",
                "name": "rentalNeeds",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Area",
                "kind": "LinkedField",
                "name": "defaultNeedsNotificationAreas",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Area",
                "kind": "LinkedField",
                "name": "defaultPropertyNotificationAreas",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c25add171816d10c993e0902ec398c9a",
    "id": null,
    "metadata": {},
    "name": "EmailPreferencesPageRelayQuery",
    "operationKind": "query",
    "text": "query EmailPreferencesPageRelayQuery {\n  userNotificationSettingsV5 {\n    ...NotificationSettings_userNotificationSettings\n    nodeId\n  }\n  currentChapterV5 {\n    ...NotificationSettings_chapter\n    nodeId\n  }\n}\n\nfragment NotificationSettingsBroadcastMessages_notificationSetting on UserNotificationSettingsV5 {\n  nodeId\n  broadcastMessages {\n    setting\n  }\n}\n\nfragment NotificationSettingsBuyerNeeds_chapter on ChapterV5 {\n  ...NotificationSettingsPreferenceEditDialog_chapter\n  ...NotificationSettingsComponentsPreferenceSummary_chapter\n}\n\nfragment NotificationSettingsBuyerNeeds_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  buyerNeeds {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomClientNeedNotificationPreference {\n      maxPrice\n      minPrice\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_clientNeed\n    }\n  }\n}\n\nfragment NotificationSettingsComponentsAreaGroupItem_chapter on ChapterV5 {\n  displayName\n}\n\nfragment NotificationSettingsComponentsPreferenceSummary_chapter on ChapterV5 {\n  ...NotificationSettingsComponentsAreaGroupItem_chapter\n}\n\nfragment NotificationSettingsComponents_byType on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  ... on UserAreaGroup {\n    __typename\n  }\n  ... on ChapterAreaGroup {\n    __typename\n  }\n}\n\nfragment NotificationSettingsComponents_group on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  id\n  areas {\n    id\n    label\n    nodeId\n  }\n  ... on UserAreaGroup {\n    usedFor\n  }\n  ...NotificationSettingsComponents_byType\n}\n\nfragment NotificationSettingsForSaleProperties_chapter on ChapterV5 {\n  ...NotificationSettingsPreferenceEditDialog_chapter\n  ...NotificationSettingsComponentsPreferenceSummary_chapter\n}\n\nfragment NotificationSettingsForSaleProperties_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  forSaleProperties {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomPropertyNotificationPreference {\n      maxPrice\n      minPrice\n      mlsStatus\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_preference\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter on ChapterV5 {\n  displayName\n}\n\nfragment NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  id\n  areas {\n    id\n    label\n    type_: type\n    nodeId\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialogAreaGroups_chapter on ChapterV5 {\n  ...NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter\n  displayName\n  notificationPreferences {\n    forSaleProperties {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup\n      }\n    }\n    rentalProperties {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup\n      }\n    }\n    buyerNeeds {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup\n      }\n    }\n    rentalNeeds {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup\n      }\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialogAreaGroups_settings on UserNotificationSettingsV5 {\n  userAreaGroups {\n    id\n    usedFor\n    areas {\n      id\n      label\n      type_: type\n      nodeId\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_areaGroup on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  ... on ChapterAreaGroup {\n    id\n    areas {\n      label\n      id\n      type_: type\n      nodeId\n    }\n  }\n  ... on UserAreaGroup {\n    id\n    areas {\n      id\n      label\n      type_: type\n      nodeId\n    }\n    usedFor\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_chapter on ChapterV5 {\n  ...NotificationSettingsPreferenceEditDialogAreaGroups_chapter\n  notificationPreferences {\n    forSaleProperties {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialog_areaGroup\n      }\n    }\n    rentalProperties {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialog_areaGroup\n      }\n    }\n    buyerNeeds {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialog_areaGroup\n      }\n    }\n    rentalNeeds {\n      areaGroup {\n        ...NotificationSettingsPreferenceEditDialog_areaGroup\n      }\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_clientNeed on CustomClientNeedNotificationPreference {\n  maxPrice\n  minPrice\n  propertyTypes\n  areaGroup {\n    __typename\n    ...NotificationSettingsPreferenceEditDialog_areaGroup\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_preference on CustomPropertyNotificationPreference {\n  maxPrice\n  minPrice\n  mlsStatus\n  propertyTypes\n  areaGroup {\n    __typename\n    ...NotificationSettingsPreferenceEditDialog_areaGroup\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_settings on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialogAreaGroups_settings\n}\n\nfragment NotificationSettingsRentalNeeds_chapter on ChapterV5 {\n  ...NotificationSettingsPreferenceEditDialog_chapter\n  ...NotificationSettingsComponentsPreferenceSummary_chapter\n}\n\nfragment NotificationSettingsRentalNeeds_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  rentalNeeds {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomClientNeedNotificationPreference {\n      maxPrice\n      minPrice\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_clientNeed\n    }\n  }\n}\n\nfragment NotificationSettingsRentalProperties_chapter on ChapterV5 {\n  ...NotificationSettingsPreferenceEditDialog_chapter\n  ...NotificationSettingsComponentsPreferenceSummary_chapter\n}\n\nfragment NotificationSettingsRentalProperties_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  rentalProperties {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomPropertyNotificationPreference {\n      maxPrice\n      minPrice\n      mlsStatus\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_preference\n    }\n  }\n}\n\nfragment NotificationSettings_areas on Area {\n  id\n  label\n  type_: type\n}\n\nfragment NotificationSettings_chapter on ChapterV5 {\n  displayName\n  ...NotificationSettingsForSaleProperties_chapter\n  ...NotificationSettingsRentalProperties_chapter\n  ...NotificationSettingsBuyerNeeds_chapter\n  ...NotificationSettingsRentalNeeds_chapter\n  notificationPreferences {\n    defaultNeedsNotificationAreas {\n      ...NotificationSettings_areas\n      nodeId\n    }\n    defaultPropertyNotificationAreas {\n      ...NotificationSettings_areas\n      nodeId\n    }\n  }\n}\n\nfragment NotificationSettings_userNotificationSettings on UserNotificationSettingsV5 {\n  ...NotificationSettingsForSaleProperties_notificationSetting\n  ...NotificationSettingsRentalProperties_notificationSetting\n  ...NotificationSettingsBuyerNeeds_notificationSetting\n  ...NotificationSettingsRentalNeeds_notificationSetting\n  ...NotificationSettingsBroadcastMessages_notificationSetting\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
